import { render } from "./Taille.vue?vue&type=template&id=dd698162"
import script from "./Taille.vue?vue&type=script&lang=js"
export * from "./Taille.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__